<template>
  <div class="behaviorTagretAdd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <!-- 物业人员 -->
        <el-form-item label="物业人员" prop="staffId">
          <el-select class="item-input" v-model="ruleForm.staffId" placeholder="请选择物业人员" @change="changeStaff"
            filterable>
            <el-option v-for="item in staffList" :key="item.id" :value="item.id" :label="item.idNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="分数" prop="point">
          <el-input-number v-model="ruleForm.point" @change="pointChange" :min="-100" :max="100"></el-input-number>
          <el-tooltip class="item" effect="light" content="可以输入-100至100之间的整数" placement="right">
            <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item tem label="情节描述" prop="remark">
          <el-input v-model="ruleForm.remark" placeholder="请输入情节描述" class="item-input" type="textarea" :rows="7">
          </el-input>
        </el-form-item>
        <!-- 附件 -->
        <el-form-item label="上传图片">
          <upload-morefile ref="uploading" :accept='accept' :fileList='fileslist' upTypes='1' :clears='clears' @outputFile="getFile"
            @removeFile='removeFile'></upload-morefile>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:behaviorTagretAdd
   *@Description:行为指标管理-编辑/新增
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  import uploadmoreFile from '../../../components/upload_morefile.vue'
  export default {
    data() {
      return {
        clears: false,
        accept: '.jpg, .jpeg, .png',
        fileslist: [], // 图片list
        fileList: [], // 图片list
        staffList: [], // 物业人员列表
        saveData: '',
        isDisabled: true, // 保存的可点击
        isFlag: false, // 编辑:true 新增：false
        rules: {
          staffId: [{
            required: true,
            message: '请选择物业人员',
            trigger: 'change'
          }],
          point: [{
            required: true,
            message: '请输入分数',
            trigger: 'blur'
          }],
          remark: [{
            required: true,
            message: '请输入情节描述',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          id: '', // 序号
          gardenId: '', // 小区id
          staffId: '', // 物业人员id
          staffName: '', // 物业人员姓名
          point: '', // 分数
          remark: '', // 情节描述
          fj: '', // 附件

        },
      }
    },
    computed: {
      ...mapGetters(['gardenId']),
    },
    components: {
      'upload-morefile': uploadmoreFile
    },
    destroyed() {
      window.localStorage.setItem('behaviorTagretform', JSON.stringify(this.ruleForm))
    },
    created() {
      this.getStaffList()
      // 判断编辑与新增
      this.isFlag = this.$route.query.flag
      if (window.localStorage.getItem('behaviorTagretform')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('behaviorTagretform'))
      } else {
        if (this.$route.query.object) {
          console.log(this.$route.query.object)
          // 编辑
          console.log('编辑')
          this.getData()
        } else {
          // 新增
          console.log('新增')
        }
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 获取组件值
      getFile(e) {
        console.log('getFile : ' + this.fileslist)
        console.log('getFile 1 : ' + JSON.stringify(e))
        this.fileList.push({
          name: '',
          url: e
        })
        this.isDisabled = false
      },
      // 移除图片
      removeFile(e) {
        let list1 = []
        for (let i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].url === e) {

          } else {
            list1.push(this.fileList[i])
          }
        }
        this.fileList = list1
        this.isDisabled = false
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'behaviorTagretList'
        })
      },
      // 获取物业人员列表
      getStaffList() {
        let loading = this.$loading()
        this.$get(
          `/staffs?pageSize=9999&pageNo=1&gardenId=${this.$store.getters.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.staffList = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 修改物业人员
      changeStaff(value) {
        console.log(value)
        this.ruleForm.staffId = value
        this.ruleForm.staffName = ([...this.staffList].filter(item => item.id == value))[0].idNo
      },
      // 修改分数
      pointChange(value) {
        let num = (value.toString().replace(/[^\-\d]/g, '')) - 0
        this.ruleForm.point = num
      },
      // 业主通知编辑页面获取数据
      getData() {
        console.log('object', this.$route.query.object)
        // 这是用来双向绑定,由于字段名称不同，所以一一对应
        this.ruleForm.id = this.$route.query.object.id
        this.ruleForm.gardenId = this.gardenId
        this.ruleForm.staffId = this.$route.query.object.staffId
        this.ruleForm.staffName = this.$route.query.object.staffName
        this.ruleForm.point = this.$route.query.object.point
        this.ruleForm.remark = this.$route.query.object.remark
        this.ruleForm.fj = this.$route.query.object.fj
        console.log('getData', this.ruleForm)
        for (let item of this.$route.query.object.fjList) {
          this.fileslist.push({
            name: '',
            url: item
          })

          this.fileList.push({
            name: '',
            url: item
          })
        }
        // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
        this.saveData = JSON.stringify(this.ruleForm)
      },

      // 保存
      save(formName) {
        console.log('save', this.ruleForm)
        let params = {}
        if (this.isFlag) {
          params.id = this.ruleForm.id
        }
        this.fileslist = []
        if (this.fileList.length > 0) {
          for (let i = 0; i < this.fileList.length; i++) {
            this.fileslist.push(this.fileList[i].url)
          }
        }
        console.log(this.fileslist)
        params.gardenId = this.gardenId
        params.staffId = this.ruleForm.staffId
        params.staffName = this.ruleForm.staffName
        params.point = this.ruleForm.point
        params.remark = this.ruleForm.remark
        params.fj = this.fileslist.toString()
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            // 新增
            if (!params.id) {
              this.$post('/senceAction', params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    console.log(res)
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'behaviorTagretList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/senceAction/${this.ruleForm.id}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'behaviorTagretList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.$refs.ruleForm.clearValidate()
        this.clears = true
        this.ruleForm.staffId = ''
        this.ruleForm.point = ''
        this.ruleForm.remark = ''
        this.ruleForm.fj = []
      },
    },
  }
</script>

<style lang="scss">
  .behaviorTagretAdd {
    .item-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>